import React, { useCallback } from 'react';
import { Trans } from '@lingui/macro';
import { Nav, Box, CrownFilled, Flex } from '@landr/maestro';
import { useFreemiumGatingCta } from 'components/FreemiumGatingCta/FreemiumGatingCta';
import { useEligibleForFreeTrial } from '@landr/pricing';
import { useUnlockPlanRedirect } from '../hooks/useUnlockPlanRedirect';

export const StartFreeTrial = ({ onClick }: { onClick?: () => void }) => {
    const { handleOnClick: handleOnClickFreemiumGating } = useFreemiumGatingCta(
        {
            analyticVariant: 'RemainingCredits',
        },
    );
    const unlockWithPlanRedirect = useUnlockPlanRedirect();

    const { isEligibleForTrial } = useEligibleForFreeTrial();

    const handleOnClick = useCallback(() => {
        handleOnClickFreemiumGating();
        onClick?.();
    }, [handleOnClickFreemiumGating, onClick]);

    return (
        <Nav.Link
            onClick={
                isEligibleForTrial ? handleOnClick : unlockWithPlanRedirect
            }
        >
            <Flex alignItems="center">
                <Box mr="xs" height="26px">
                    <CrownFilled size="sm" color="warning.500" />
                </Box>
                {isEligibleForTrial ? (
                    <Trans>Start free trial</Trans>
                ) : (
                    <Trans>Unlock with a plan</Trans>
                )}
            </Flex>
        </Nav.Link>
    );
};
